export default "__VITE_ASSET__9pBeIVXd__"